import React from "react";
import styles from "./TwoColumnLayout.module.css";

interface TwoColumnLayoutProps {
  left: React.ReactNode;
  right: React.ReactNode;
}

/**
 * Generic two-column layout. Left and right sections receive arbitrary content.
 */
const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({ left, right }) => (
  <div className={styles.container}>
    <div className={styles.left}>{left}</div>
    <div className={styles.right}>{right}</div>
  </div>
);

export default TwoColumnLayout;
